import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

export type CellIntegerProps = TableInheritedProps & {
  empty?: string;
  formatOptions?: Intl.NumberFormatOptions;
};

export const CellIntegerBase = ({
  empty = '-',
  formatOptions,
  ...props
}: CellIntegerProps) => {
  const { locale } = useTranslation();
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const value = useMemo(() => {
    const raw = getValue!();
    return raw == null || raw === ''
      ? empty
      : new Intl.NumberFormat(locale.replaceAll('_', '-'), {
          maximumFractionDigits: 20,
          ...formatOptions
        }).format(Number(raw));
  }, [empty, formatOptions, getValue, locale]);

  return <div {...inheritedProps}>{value}</div>;
};

export const CellInteger = (props: CellIntegerProps) =>
  useGlobalComponent('CellInteger', CellIntegerBase, props);
